import React, { useState, useEffect } from "react";
import "../styles/Trayectoria.css";
import { MapPin } from "lucide-react";
import { Modal, Button, Accordion } from "react-bootstrap";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import geoData from "../assets/maps/countries.geojson";

const geoUrl = geoData;

const countryCoordinates = {
  Colombia: [-74.2973, 4.5709],
  Peru: [-75.0152, -9.1899],
  Chile: [-71.542969, -35.675147],
  Ecuador: [-78.1834, -1.8312],
  Mexico: [-102.5528, 23.6345],
  USA: [-95.7129, 37.0902],
  Argentina: [-63.6167, -38.4161],
};

const Trayectoria = ({ traducciones }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Detecta si la pantalla es móvil
    };

    handleResize(); // Ejecuta al cargar
    window.addEventListener("resize", handleResize); // Escucha cambios de tamaño

    return () => window.removeEventListener("resize", handleResize); // Limpia el evento
  }, []);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setHoveredCountry(null);
  };

  const cardsData = [
    {
      title: "Colombia",
      dataList: [
        "Equion Energía",
        "Ecopetrol",
        "TGI",
        "Corficolombiana",
        "Exterran",
        "Brinsa SA",
        "Masa Stork",
        "PetroSantander",
        "Parex",
        "Geopark",
        "Gran Tierra Energy",
        "Transmetano",
        "Lavalin",
        "Indumil",
        "ARL Seguros Bolívar",
        "Emerald",
        "Inemec",
        "ODL",
        "P1 Energy",
        "Petrocolombia",
        "Petropuli",
        "Ramshorn",
        "Rempower",
        "Sogomy Energy",
        "Simmgla",
        "Tipiel SA",
        "Termoyopal",
        "Woodgroup",
      ],
    },
    {
      title: "Peru",
      dataList: [
        "Pacific Energy",
        "Pluspetrol",
        "Stork Perú",
        "BPZ",
        "Sertecpet",
        "Tepsi Perú",
        "Woodgroup Perú",
      ],
    },
    {
      title: "Chile",
      dataList: ["ENAP"],
    },
    {
      title: "Ecuador",
      dataList: ["ENAP Ecuador", "CPP"],
    },
    {
      title: "Mexico",
      dataList: ["Schlumberger", "Lukoil Energy", "Lewis Energy"],
    },
    {
      title: "USA",
      dataList: [
        "Advent Int.",
        "Woodside Energy",
        "Camif II",
        "Fieldwood Energy",
      ],
    },
    {
      title: "Argentina",
      dataList: ["ENAP Sipetrol", "Vista Energy", "Techint"],
    },
  ];

  return (
    <div className="trayectoria-container py-5">
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-lg-6 col-md-6 col-sm-12 text-start">
            <h2 className="titulo-trayectoria mb-4">
              {traducciones.trayectoria
                ? traducciones.trayectoria.titulo
                : "TRAYECTORIA"}
            </h2>
            <div
              className="texto-trayectoria"
              dangerouslySetInnerHTML={{
                __html: traducciones.trayectoria
                  ? traducciones.trayectoria.texto
                  : "",
              }}
            ></div>
          </div>
        </div>
        <div className="row text-center mt-4 bloque-circulos d-flex justify-content-center">
          <div className="col-lg-2 col-md-3 col-sm-6 mb-4">
            <div className="circulo">+150</div>
            <p className="texto-circulo">
              {traducciones.trayectoria
                ? traducciones.trayectoria.contratos
                : "Contratos ejecutados."}
            </p>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-4">
            <div className="circulo">+45</div>
            <p className="texto-circulo">
              {traducciones.trayectoria
                ? traducciones.trayectoria.clientes
                : "Clientes."}
            </p>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-4">
            <div className="circulo">
              {traducciones.idioma === "en" ? "+4" : "+11k"}
            </div>
            <p className="texto-circulo">
              {traducciones.trayectoria
                ? traducciones.trayectoria.millones
                : "Millones de pesos facturados en consultoría y servicios."}
            </p>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-4">
            <div className="circulo">0</div>
            <p className="texto-circulo">
              {traducciones.trayectoria
                ? traducciones.trayectoria.incidentes
                : "Incidentes en el ejercicio de nuestros servicios."}
            </p>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-4">
            <div className="circulo">
              <MapPin size={65} />
            </div>
            <p className="texto-circulo">
              {isMobile ? (
                <Button className="boton-trayectoria" onClick={handleOpenModal}>
                  {traducciones.trayectoria
                    ? traducciones.trayectoria.boton
                    : "Ver países"}
                </Button>
              ) : (
                <Button className="boton-trayectoria" onClick={handleOpenModal}>
                  {traducciones.trayectoria
                    ? traducciones.trayectoria.boton
                    : "7 Países"}
                </Button>
              )}
            </p>

            {/* Modal */}
            <Modal
              show={isModalOpen}
              onHide={handleCloseModal}
              size={isMobile ? "sm" : "xl"} // Tamaño del modal según el dispositivo
              centered
              dialogClassName="custom-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {isMobile ? "Países de Trayectoria" : "Mapa de Trayectoria"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  height: isMobile ? "auto" : "80vh",
                }}
              >
                {isMobile ? (
                  // Lista tipo acordeón para móviles
                  <Accordion>
                    {cardsData.map((country, index) => (
                      <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>{country.title}</Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {country.dataList.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                ) : (
                  // Mapa para pantallas grandes
                  <>
                    <div
                      style={{
                        flex: 5,
                        padding: "10px",
                      }}
                    >
                      <ComposableMap>
                        <Geographies geography={geoUrl}>
                          {({ geographies }) =>
                            geographies.map((geo) => {
                              const countryName =
                                geo.properties.NAME ||
                                geo.properties.ADMIN ||
                                geo.properties.name;

                              if (!countryName) {
                                return null;
                              }

                              const countryData = cardsData.find(
                                (card) => card.title === countryName
                              );

                              return (
                                <Geography
                                  key={geo.rsmKey}
                                  geography={geo}
                                  style={{
                                    default: {
                                      fill: countryData ? "#FFE4A1" : "#D6D6DA",
                                    },
                                    hover: { fill: "#F53" },
                                    pressed: { fill: "#E42" },
                                  }}
                                  onMouseEnter={() =>
                                    setHoveredCountry(countryData || null)
                                  }
                                  onMouseLeave={() => setHoveredCountry(null)}
                                  onClick={() =>
                                    setSelectedCountry(countryData || null)
                                  }
                                />
                              );
                            })
                          }
                        </Geographies>

                        {/* Agregar nombres de países con datos */}
                        {cardsData.map((country) => {
                          const coordinates = countryCoordinates[country.title];
                          if (!coordinates) return null;

                          return (
                            <Marker
                              key={country.title}
                              coordinates={coordinates}
                            >
                              <text
                                x={-15} // Desplaza el texto hacia la derecha del marcador
                                y={4} // Ajusta la posición vertical del texto
                                textAnchor="start" // Alinea el texto a la izquierda
                                style={{
                                  fontFamily: "Arial",
                                  fontSize: "10px",
                                  fill: "#333",
                                  fontWeight: "bold",
                                }}
                              >
                                {country.title}
                              </text>
                            </Marker>
                          );
                        })}
                      </ComposableMap>
                    </div>
                    <div
                      style={{
                        flex: 2,
                        padding: "20px",
                        backgroundColor: "#f9f9f9",
                        borderLeft: "1px solid #ccc",
                        overflowY: "auto",
                      }}
                    >
                      {selectedCountry || hoveredCountry ? (
                        <>
                          <h3 style={{ marginBottom: "10px" }}>
                            {(selectedCountry || hoveredCountry).title}
                          </h3>
                          <ul>
                            {(selectedCountry || hoveredCountry).dataList.map(
                              (item, idx) => (
                                <li key={idx}>{item}</li>
                              )
                            )}
                          </ul>
                          {selectedCountry && (
                            <button
                              style={{
                                marginTop: "10px",
                                padding: "10px 15px",
                                backgroundColor: "#007bff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => setSelectedCountry(null)}
                            >
                              Cerrar lista
                            </button>
                          )}
                        </>
                      ) : (
                        <p>
                          Pasa el mouse sobre un país o haz clic para ver más
                          información.
                        </p>
                      )}
                    </div>
                  </>
                )}
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trayectoria;
